import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';
import { initialContentState } from '../../models/contentModel';

export const fetchContent = createAsyncThunk(
    'content/fetchContent',
    async (_, thunkAPI) => {
        try {
            const response = await apiService('/Content/GetSingle');
            if (response.isSuccess) {
                return response.result;
            } else {
                return thunkAPI.rejectWithValue(response.message || 'Hata oluştu');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const contentSlice = createSlice({
    name: 'content',
    initialState: initialContentState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchContent.fulfilled, (state, action) => {
                state.loading = false;
                state.dataContent = action.payload;
            })
            .addCase(fetchContent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default contentSlice.reducer;
